<template>
  <div class="rounded-2xl max-w-sm p-4 mx-auto border border-brand">
    <h2 class="text-title-xs" v-text="title" />
    <section class="mb-4">
      <schema-form
        class="schema-form"
        :schema="schema"
        v-model:modelValue="formData"
      />
    </section>
    <section class="mb-4">
      <div class="grid grid-cols-3 gap-2">
        <div
          v-for="option in validOptions"
          :key="`${option.days}_${option.title}`"
          v-text="option.title"
          class="rounded-2xl hover-hover:hover:bg-brand hover-hover:hover:text-white p-2 text-center uppercase border border-brand cursor-pointer"
          :class="{
            'bg-accent': activeOption.title === option.title
          }"
          @click="activeOption = option"
        />
      </div>
    </section>
    <section class="mb-4">
      <div class="mb-2 prose" v-html="rendimento" />
    </section>
    <section class="mb-4">
      <div class="grid grid-cols-3 gap-2 text-white break-words">
        <div class="flex flex-col p-2 bg-brand rounded-md">
          <span v-text="activeOption.grossratelabel" class="font-bold" />
          <span
            v-text="`${toCurrency(round(gross))}`"
            class="block mt-auto text-xl font-extrabold"
          />
        </div>
        <div class="flex flex-col p-2 bg-brand rounded-md">
          <span v-text="activeOption.taxeslabel" class="font-bold" />
          <span
            v-text="`${toCurrency(round(tax))}`"
            class="block mt-auto text-xl font-extrabold"
          />
        </div>
        <div class="text-primary flex flex-col p-2 bg-brand rounded-md">
          <span v-text="activeOption.netratelabel" class="font-bold" />
          <span
            v-text="`${toCurrency(round(result))}`"
            class="block mt-auto text-xl font-extrabold"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import * as yup from "yup";
import { setLocale } from "yup";
import _ from "lodash";

setLocale({
  mixed: {
    notType: ""
  }
});

export default {
  props: ["title", "description", "options"],
  data: vm => ({
    activeOption: _.first(vm.options),
    formData: {
      trimestrale: false,
      amount: 100000
    }
  }),
  watch: {
    "formData.trimestrale": function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.activeOption =
          _.find(this.validOptions, i => i.title === "18 mesi") ||
          _.first(this.validOptions);
      }
    }
  },
  mounted() {
    this.activeOption =
      _.find(this.validOptions, i => i.title === "18 mesi") ||
      _.first(this.validOptions);
  },
  computed: {
    amounterrormessage() {
      return _.replace(
        this.activeOption.amounterrormessage,
        "{0}",
        this.activeOption.amountlimit &&
          _.toNumber(this.activeOption.amountlimit).toLocaleString()
      );
    },
    rendimento() {
      let text = _.replace(
        this.activeOption.grossreturnlabel,
        "{0}",
        this.activeOption.standardrate &&
          _.toNumber(this.activeOption.standardrate).toLocaleString("it-IT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
      );
      text = _.replace(
        text,
        "{1}",
        this.activeOption.amountlimit &&
          _.toNumber(this.activeOption.amountlimit).toLocaleString()
      );
      return text;
    },
    schema() {
      return {
        amount: {
          component: "form-text",
          label: this.description,
          model: "amount",
          type: "text",
          max: _.toNumber(this.activeOption.amountlimit),
          min: 1,
          isInteger: true,
          maxlength: 7,
          validations: yup
            .number()
            .max(this.activeOption.amountlimit, this.amounterrormessage)
            .integer(this.amounterrormessage),
          fieldClasses: {
            input: "bg-brand text-white"
          }
        },
        trimestrale: {
          component: "form-checkbox", //FormText,
          label:
            this.activeOption.couponlabel || _.first(this.options).couponlabel,
          model: "trimestrale",
          fieldClasses: {
            input: "bg-white border-2 border-brand"
          }
        }
      };
    },
    validOptions() {
      return _.filter(
        this.options,
        i => i.coupon === this.formData.trimestrale
      );
    },
    gross() {
      return (
        (_.toNumber(this.formData.amount) *
          _.toNumber(this.activeOption.standardrate) *
          _.toNumber(_.replace(this.activeOption.days, /\D/g, ""))) /
        100 /
        365
      );
    },
    tax() {
      return (this.gross * _.toNumber(this.activeOption.grossrate)) / 100;
    },
    result() {
      return this.gross - this.tax;
    }
  },
  methods: {
    round(val) {
      const result = _.isNan(_.round(val)) ? 0 : _.round(val);
      return result;
    },
    toCurrency(val, minDigits = 0, maxDigits = 0) {
      return val.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits
      });
    }
  }
};
</script>
